/* Quick view: native <dialog> + owl-carousel. Markup comes from <template id="QuickViewTemplate">
   (snippets/quickview.liquid); owl init is handled by theme-carousel.js as soon as
   the .owl-carousel elements are in the DOM. jQuery stays for the cart hooks
   (.cart-content, #cart_reload) that the rest of the theme uses too. */
(function () {
  var dialog = null, product = null, handle = '';

  function $q(sel) { return dialog.querySelector(sel); }
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ','); }
  function imgUrl(url, w) { return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function ensureDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'quick-view-dialog';
    dialog.innerHTML = '<div id="quick-view"></div>';
    document.body.appendChild(dialog);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog || e.target.closest('[data-quick-view-close]')) close();
    });
    dialog.addEventListener('close', function () { $q('#quick-view').innerHTML = ''; product = null; });
    dialog.addEventListener('change', function (e) { if (e.target.matches('#quick-view select')) onOptionChange(); });
    dialog.addEventListener('click', function (e) {
      var thumb = e.target.closest('.qv-product-images-variant [data-index]');
      if (thumb) goTo(parseInt(thumb.getAttribute('data-index'), 10));
      if (e.target.closest('.qv-add-button')) { e.preventDefault(); addToCart(); }
    });
    return dialog;
  }

  function goTo(i) {
    window.jQuery('#quick-view .qv-product-images').trigger('to.owl.carousel', [i, 200]);
  }

  function selectedVariant() {
    var sel = Array.prototype.map.call(dialog.querySelectorAll('#quick-view select'), function (s) { return s.value; });
    var title = sel.join(' / ');
    for (var i = 0; i < product.variants.length; i++) if (product.variants[i].title === title) return product.variants[i];
    return null;
  }

  function renderVariant(v) {
    if (!v) return;
    $q('.qv-product-price').textContent = money(v.price);
    var op = $q('.qv-product-original-price');
    if (v.compare_at_price && v.compare_at_price > v.price) { op.textContent = money(v.compare_at_price); $q('.original-price').style.display = ''; }
    else { $q('.original-price').style.display = 'none'; }
    var sku = $q('.qv-sku');
    if (v.sku) { sku.classList.add('show'); sku.classList.remove('hide'); $q('.qv-view-sku').textContent = v.sku; }
    else { sku.classList.add('hide'); sku.classList.remove('show'); }
    // A price-on-request variant (price 0) is never added from quick view; the product page has the quote form.
    $q('.qv-add-to-cart').style.display = v.price === 0 ? 'none' : '';
    var btn = $q('.qv-add-button');
    btn.disabled = !v.available || v.price === 0;
    btn.value = v.available ? window.variantStrings.addToCart : window.variantStrings.soldOut;
    if (v.featured_image) goTo(v.featured_image.position - 1);
  }

  function onOptionChange() { renderVariant(selectedVariant()); }

  function build() {
    var tpl = document.getElementById('QuickViewTemplate');
    var root = $q('#quick-view');
    root.innerHTML = '';
    root.appendChild(tpl.content.cloneNode(true));

    $q('.qv-product-title').textContent = product.title;
    $q('.qv-product-type').textContent = product.type;
    if (!product.type) $q('.qv-product-type-title').style.display = 'none';
    $q('.qv-view-vendor').textContent = product.vendor;
    if (!product.vendor) $q('.qv-view-vendor-title').style.display = 'none';
    $q('.qv-product-description').innerHTML = product.description || '';
    $q('.view-product').setAttribute('href', '/products/' + handle);

    var main = $q('.qv-product-images'), thumbs = $q('.qv-product-images-variant');
    product.images.forEach(function (src, i) {
      var d = document.createElement('div');
      d.innerHTML = '<img src="' + imgUrl(src, 1000) + '" alt="" width="1000" height="1000" loading="' + (i ? 'lazy' : 'eager') + '">';
      main.appendChild(d);
      var t = document.createElement('div');
      t.className = 'images-variant'; t.setAttribute('data-index', i);
      t.innerHTML = '<img src="' + imgUrl(src, 200) + '" alt="" width="200" height="200" loading="lazy">';
      thumbs.appendChild(t);
    });
    if (product.images.length > 1) {
      main.classList.add('owl-carousel'); main.setAttribute('data-carousel', '{"items":{"0":1},"loop":false}');
      thumbs.classList.add('owl-carousel'); thumbs.setAttribute('data-carousel', '{"items":{"0":3},"loop":false}');
    } else {
      thumbs.style.display = 'none';
    }

    var opts = $q('.qv-product-options');
    if (product.options.length === 1 && product.options[0].values.length === 1 && product.options[0].values[0] === 'Default Title') {
      opts.style.display = 'none';
    }
    product.options.forEach(function (option, i) {
      var wrap = document.createElement('div');
      wrap.className = 'option-selection-' + option.name.toLowerCase();
      var label = document.createElement('span'); label.className = 'option'; label.textContent = option.name;
      var select = document.createElement('select'); select.className = 'field__input option-' + i + ' option';
      option.values.forEach(function (val) { var o = document.createElement('option'); o.value = val; o.textContent = val; select.appendChild(o); });
      wrap.appendChild(label); wrap.appendChild(select); opts.appendChild(wrap);
    });
    var first = null;
    for (var i = 0; i < product.variants.length; i++) if (product.variants[i].available) { first = product.variants[i]; break; }
    first = first || product.variants[0];
    if (first) {
      ['option1', 'option2', 'option3'].forEach(function (k, i) { var s = $q('select.option-' + i); if (s && first[k]) s.value = first[k]; });
      renderVariant(first);
    }
  }

  function addToCart() {
    var v = selectedVariant(); if (!v || v.price === 0) return;
    var qty = parseInt(($q('.qv-quantity') || {}).value, 10) || 1;
    var $ = window.jQuery;
    $.post(window.routes.cart_add_url + '.js', { quantity: qty, id: v.id }, null, 'json').done(function () {
      $('.cart-content').addClass('active');
      $('.overlay').addClass('overlay_active');
      $('#loader').addClass('loader');
      setTimeout(function () { $('#loader').removeClass('loader'); }, 1000);
      $('#cart_reload').load('#cart_reload .cart_content > *');
      $('.cart-count-bubble').load(' .cart-count-bubble > *');
      $('.qv-add-to-cart-response').removeClass('error').addClass('success');
      $('.qv-add-to-cart-response .msg').delay(3000).fadeTo(1000, 0);
      $('.qv-add-to-cart-response .msg').removeAttr('style');
      close();
    });
  }

  function open(h) {
    handle = h;
    ensureDialog();
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
      product = p;
      build();
      if (!dialog.open) dialog.showModal();
    });
  }

  function close() { if (dialog && dialog.open) dialog.close(); }

  document.addEventListener('click', function (e) {
    var link = e.target.closest('.quick-view');
    if (!link) return;
    e.preventDefault();
    open(link.getAttribute('data-handle'));
  });
})();
